// @flow
import styled from 'styled-components';
import { below } from '../../assets/css/media';

const getBorder = ({ background, border }) => {
	if (border) {
		return border;
	}
	if (!background) {
		return 'transparent';
	}
	return background.toLowerCase().substr(0,4) === '#fff' ? `#DFDFDF` : background;
};

export const PlayerRowMenuButton = styled.button`
	height: 50px;
	width: 50px;
	margin-right: ${({ margin }) => margin || '2px'};
	background: ${({ background }) => background || 'transparent'};
	color: ${({ color }) => color || '#fff'};
	outline: none;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 2px;
	border: 1px solid ${getBorder};
	box-sizing: border-box;
	${({ is_margin }) => is_margin ? 'margin: 0 7px' : ''};
	${below.desktop`
		height: 40px;
		width: 40px
	`}
	:disabled {
		cursor: not-allowed;
		pointer-events: none;
	}
`;

export default PlayerRowMenuButton;


// WEBPACK FOOTER //
// ./src/components/PlayerRowMenuButton/index.js